__turbopack_context__.v({
  "Content": "InductionSteps-module-sass-module__wc8yqW__Content",
  "InductionSteps": "InductionSteps-module-sass-module__wc8yqW__InductionSteps",
  "Left": "InductionSteps-module-sass-module__wc8yqW__Left",
  "PreTitle": "InductionSteps-module-sass-module__wc8yqW__PreTitle",
  "Step": "InductionSteps-module-sass-module__wc8yqW__Step",
});
